import React from 'react';
import type { NoteField } from '../../types/disclosure';
interface NotesPanelProps {
  notes: NoteField[];
  showApiNames: boolean;
}
export function NotesPanel({
  notes,
  showApiNames
}: NotesPanelProps) {
  const [primary, ...supporting] = notes;
  return <div className="grid items-stretch gap-4 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)]" data-id="element-41" data-mp="3bwl7p9onmmdy">
      <article className="flex min-h-[220px] flex-col rounded-md border border-blue-200 border-l-4 border-l-blue-600 bg-blue-50/50 px-3.5 py-3" data-id="element-42" data-mp="37v01262pr4c7">
        <h3 className="text-[11px] font-semibold uppercase tracking-wide text-blue-800" data-id="element-43" data-mp="2xyddvamx0170">{primary.label}</h3>
        {showApiNames && <p className="font-mono text-[10px] text-blue-500" data-id="element-44" data-mp="2t0lfbxrrlgtu">{primary.api}</p>}
        {primary.value ? <p className="mt-2 whitespace-pre-line text-[13px] leading-6 text-slate-800" data-id="element-45" data-mp="2ozt44yzc11ux">{primary.value}</p> : <p className="mt-2 text-[13px] italic text-slate-400" data-id="element-46" data-mp="r6cnsgjeg6on">No roadmap notes recorded.</p>}
      </article>

      <div className="grid gap-2.5 sm:grid-cols-2" data-id="element-47" data-mp="37njh3bkkjcs0">
        {supporting.map(note => <article key={note.id} className="flex min-h-[104px] flex-col rounded-md border border-slate-200 bg-white px-3.5 py-3" data-id="element-48" data-mp="37pw80e8b0xh7">
            <h3 className="text-[11px] font-semibold uppercase tracking-wide text-slate-500" data-id="element-49" data-mp="2yofye8pbcze1">{note.label}</h3>
            {showApiNames && <p className="font-mono text-[10px] text-slate-400" data-id="element-50" data-mp="32qje59j0mq54">{note.api}</p>}
            {note.value ? <p className="mt-1.5 whitespace-pre-line text-[13px] leading-6 text-slate-800" data-id="element-51" data-mp="3qgdptnrlm8ns">{note.value}</p> : <p className="mt-1.5 text-[13px] italic text-slate-400" data-id="element-52" data-mp="3hm92vffl5hdj">Not provided</p>}
          </article>)}
      </div>
    </div>;
}